import { createContext, useContext } from 'react';
import { FormInstance } from '../FormInstance';
import { FieldInstance } from '../../Field';
import { FieldErrorMap } from '../FieldErrorMap';

export type IFormContext<T extends Record<string, any>> = FormInstance<T> & {
    formFields: Array<FieldInstance<any>>;
    submit: () => Promise<void>;
};

export const initialFormContext: IFormContext<Record<string, any>> = {
    formFields: [],
    setField: (fieldInstance: FieldInstance<any>) => {},
    removeField: (fieldInstance: FieldInstance<any>) => {},
    setFieldValue: (name: string, value: any) => undefined,
    setErrors: (errorMap: FieldErrorMap<Record<string, string[]>>) => {},
    getField: (name) => null,
    errors: [],
    errorMap: {},
    reset: () => {},
    setIsTouched: () => {},
    setIsDirty: () => {},
    isValid: false,
    isDirty: false,
    isTouched: false,
    isValidating: false,
    requiredStrategy: 'required',
    values: {},
    submit: () => Promise.resolve(),
    initialValues: {},
};

export const FormContext = createContext(initialFormContext);

export const useFormContext = <T extends Record<string, any>>() => {
    return useContext(FormContext) as IFormContext<T>;
};
